// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import CompanyInformationForSuperAdminReduxForm from '../layout/reduxForm/CompanyInformationBySuperAdmin';
import onSubmit from '../../utils/reduxForm/onSubmit/companyInformationBySuperAdmin';

const EditCompanyBySuperAdmin = ({
  modalState,
  toggleModal,
  companyName,
}) => {
  const closeModal = () => {
    toggleModal(false, 'editCompanyBySuperAdmin');
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div className="popup_block dashboard-modal dashboard-modal--company showed">
      <div className="popup_container">
        <div className="popup_head">
          <div className="popup_title">{companyName}</div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>
        <CompanyInformationForSuperAdminReduxForm onSubmit={onSubmit} closeModal={closeModal} />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.editCompanyBySuperAdmin,
  companyName: state.modalState.editCompanyBySuperAdmin?.type?.name || 'Edit Company',
});

export default connect(mapStateToProps, mapDispatchToProps)(EditCompanyBySuperAdmin);
